export default "__VITE_ASSET__BlWigLIi__"